export var MessageHandlerNames = /*#__PURE__*/function (MessageHandlerNames) {
  MessageHandlerNames["UserLogin"] = "userLogin";
  MessageHandlerNames["UserLogout"] = "userLogout";
  return MessageHandlerNames;
}({});
export var sendMessageToIosApp = function sendMessageToIosApp(name, message) {
  var _window$webkit;
  (_window$webkit = window.webkit) === null || _window$webkit === void 0 || (_window$webkit = _window$webkit.messageHandlers) === null || _window$webkit === void 0 || (_window$webkit = _window$webkit[name]) === null || _window$webkit === void 0 || _window$webkit.postMessage(message);
};